// extracted by mini-css-extract-plugin
export default {"controlButton":"SikRew","hidden":"SDCtMN","fullScreenControl":"hKOrCk","fullScreenToggle":"Cn9dEu","enterIcon":"B_N5WW","exitIcon":"D7xTDF","inFullScreen":"UZeOX4"};